module.exports = {

    data() {
        return {
            progress: null,
        }
    },

    methods:{

        calculateProgress(progress) {
            this.progress = Math.round((progress.loaded * 100) / progress.total)
        },

        config() {
            return {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: this.calculateProgress
            }
        }
    }
}
